import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgDirectionalArrowLeft = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M13.231 4.318a1 1 0 0 1-.049 1.413L7.537 11H19a1 1 0 1 1 0 2H7.537l5.645 5.269a1 1 0 0 1-1.364 1.462l-7.5-7a1 1 0 0 1 0-1.462l7.5-7a1 1 0 0 1 1.413.049Z", clipRule: "evenodd" }));
};
export default factorySvgIcon(SvgDirectionalArrowLeft);
//# sourceMappingURL=SvgDirectionalArrowLeft.js.map